import React, { ReactElement } from 'react';
import {
    RewardsContainer,
    RewardsRectangle,
    RewardsRectangleLeftContainer,
    RewardsLeftHeader,
    RewardsSemiBoldTitle,
    RewardsAmount,
    RewardsAmountText,
    RewardsRectangeContainer,
    RewardsHeader,
} from './RewardsBannerStyles';

interface RewardsBannerProps {
    bannerType: string;
    headerText: ReactElement | string;
    sectionLeftText: ReactElement | string;
    sectionRightText: ReactElement | string;
    amountLeftText: ReactElement | string;
    amountRightText: ReactElement | string;
    leftRewardsBalance: string;
    rightRewardsBalance: string;
}
const REWARDS_BANNER_DATA_QA_ID = 'rewards-banner';
export const RewardsBanner = ({
    bannerType,
    headerText,
    leftRewardsBalance,
    rightRewardsBalance,
    sectionLeftText,
    sectionRightText,
    amountLeftText,
    amountRightText,
}: RewardsBannerProps) => {
    return (
        <RewardsContainer data-qa-id={REWARDS_BANNER_DATA_QA_ID}>
            <RewardsRectangle
                data-qa-id={`${REWARDS_BANNER_DATA_QA_ID}-${bannerType}`}
                className={
                    bannerType === 'points' ? 'red-rectangle-gradient' : 'blue-rectangle-gradient'
                }
            >
                <RewardsRectangleLeftContainer>
                    <RewardsLeftHeader> {headerText}</RewardsLeftHeader>
                    <RewardsSemiBoldTitle>{sectionLeftText}</RewardsSemiBoldTitle>
                    <RewardsAmount className="tst-pinn">
                        <span
                            data-qa-id={`${REWARDS_BANNER_DATA_QA_ID}-${bannerType}-amount-left-side`}
                        >
                            {leftRewardsBalance}
                        </span>
                        <RewardsAmountText>{amountLeftText}</RewardsAmountText>
                    </RewardsAmount>
                </RewardsRectangleLeftContainer>
                <RewardsRectangeContainer>
                    <RewardsHeader> &nbsp; </RewardsHeader>
                    <RewardsSemiBoldTitle>{sectionRightText}</RewardsSemiBoldTitle>
                    <RewardsAmount className="tst-pinn">
                        <span
                            data-qa-id={`${REWARDS_BANNER_DATA_QA_ID}-${bannerType}-amount-right-side`}
                        >
                            {rightRewardsBalance}
                        </span>
                        <RewardsAmountText>{amountRightText}</RewardsAmountText>
                    </RewardsAmount>
                </RewardsRectangeContainer>
            </RewardsRectangle>
        </RewardsContainer>
    );
};
